import { Typography } from '@mui/material'

export const AdminBilling = (): JSX.Element => {
  return (
    <Typography variant="h5" color="secondary.main">
      Cobrança
    </Typography>
  )
}
